import { useState, useEffect } from "react";
import axios from "axios";
import SingleItem from "../../components/singleItem/SingleItem";

import CustomPagination from "../../components/pagination/CustomPagination";
import "./Trending.css";

const Trending = () => {
  const [content, setContent] = useState();
  const [page, setPage] = useState(1);
  const fetchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/trending/all/day?api_key=49ee1b42258c9faabeec54190b777a93&page=${page}`
    );
    setContent(data.results);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [page]);

  return (
    <>
      <div>
        <span className="pageTitle">Trending Movies & Series</span>

        <div className="trending">
          {content &&
            content.map((singleContent) => (
              <SingleItem key={singleContent.id} {...singleContent} />
            ))}
        </div>
        <CustomPagination setPage={setPage} page={page} />
      </div>
    </>
  );
};

export default Trending;
